<template>
  <div id="top" class="claim-add-page">
    <div class="claim-add-intro">
      <UiPageHeader
        title="Add Claim"
        description="Create a provider claim batch, add encounter pages, and submit the completed batch for vetting."
      >
        <template #actions>
          <button type="button" class="claim-all-link" @click.prevent="handleActive(home)">
            <ArrowLeft :size="17" aria-hidden="true" />
            <span>All Claims</span>
          </button>
        </template>
      </UiPageHeader>
    </div>

    <!-- Claims Link -->
    <!-- <nav class="grey darken-2 hide-on-small-only">
    <div class="nav-wrapper container center-align">
      <ul class="tabs tabs-transparent">
        <li @click.prevent="handleReview('view')" :class="{ 'active blue-grey': !next }">
          <a href="#">View All Pages <b>({{ encounters.length ? encounters.length : 0 }})</b></a>
        </li>
        <li class="divider" tabindex="-1"></li>
        <li @click.prevent="handleReview('add')" :class="{ 'active blue-grey': next }">
          <a href="#">Add New</a>
        </li>
        <span v-if="!encounters.filter(encounter => encounter?.status === 'c' || encounter?.status === 'o').length">
          <li class="divider" tabindex="-1"></li>
          <li @click.prevent="handleClose">
            <a href="#">Close Claims</a>
          </li>
        </span>
      </ul>
    </div>
  </nav> -->

  <!-- search layer -->
  <!-- <div class="grey lighten-4 container">
    <div class="container section"></div>
  </div> -->

  <!-- Warning -->
  <ModalNotify id="notify" class="modal" :title="notifyTitle" :message="notifyMessage" @ok="handleOk"
    v-if="notifyTitle && notifyMessage" />

  <!-- Beautiful side link -->
  <!-- <a class="waves-effect waves-light btn-large btn right modal-trigger" data-target="notify">
    Open
  </a> -->

  <!-- main -->
  <div class="sba-collection-page-surface is-workbench">
    <div class="claim-add-container">
      <LoadingDiv v-if="!isReady" />

      <template v-else>
        <div class="claim-add-workbench sba-slide-in">
          <section class="claim-add-secondary-header">
            <section class="claim-add-dossier-card" v-if="cluster">
              <div class="claim-add-dossier-title">
                <label class="active teal-text">Claims Entry</label>
                <h5>{{ cluster ? capWords(cluster?.provider?.name) : "Add Provider Claims" }}</h5>
                <p>
                  Start a provider claim period, add or review encounter pages, and submit the batch for vetting when
                  the entries are complete.
                </p>
              </div>

              <div class="claim-add-dossier-context">
                <span class="context-pill" v-if="cluster">{{ cluster?.scheme?.name.toUpperCase() }}</span>
                <span class="context-pill" v-if="cluster">{{ cluster?.month?.name }} {{ cluster?.year?.name }}</span>
                <span class="context-pill" :class="{ 'is-active': currState === 'c' }">{{ currState === "c" ? "Current Batch" : "Saved Claims" }}</span>
                <span class="context-pill is-count" v-if="cluster">{{ encounters.length ? encounters.length : 0 }} pages</span>
              </div>
            </section>

            <section class="claim-add-mode-strip">
              <div class="claim-add-mode-actions">
                <button
                  v-for="tab in tabsState"
                  :key="tab.id"
                  type="button"
                  class="claim-add-mode-option"
                  :class="{ 'is-active': tab.state === currState }"
                  @click.prevent="handleState(tab.state)"
                >
                  {{ tab.title }}
                </button>
              </div>
            </section>
          </section>

          <section class="claim-add-body-frame">
            <template v-if="isReady && currState === 'c' && cluster">
              <section class="claim-add-submode-strip">
                <div class="claim-add-submode-copy">
                  <span>Batch pages</span>
                  <small>Review saved pages or add another encounter</small>
                </div>
                <div class="claim-add-submode-actions">
                  <button
                    type="button"
                    class="claim-add-submode-option"
                    :class="{ 'is-active': !next }"
                    @click.prevent="handleReview('view')"
                  >
                    View All Pages <span>({{ encounters.length ? encounters.length : 0 }})</span>
                  </button>
                  <button
                    type="button"
                    class="claim-add-submode-option"
                    :class="{ 'is-active': next }"
                    @click.prevent="handleReview('add')"
                  >
                    Add New
                  </button>
                  <button
                    v-if="!encounters.filter(encounter => encounter?.status === 'c' || encounter?.status === 'o').length"
                    type="button"
                    class="claim-add-close-option"
                    @click.prevent="handleClose"
                  >
                    <i class="material-icons">save</i>
                    Close Claims
                  </button>
                </div>
              </section>
            </template>

        <!-- <template v-if="isReady && currState === 'c' && cluster">
     <nav class="grey darken-2 hide-on-small-only">
    <div class="nav-wrapper container center-align">
      <ul class="tabs tabs-transparent">
        <li @click.prevent="handleReview('view')" :class="{ 'active blue-grey': !next }">
          <a href="#">View All Pages <b>({{ encounters.length ? encounters.length : 0 }})</b></a>
        </li>
        <li class="divider" tabindex="-1"></li>
        <li @click.prevent="handleReview('add')" :class="{ 'active blue-grey': next }">
          <a href="#">Add New</a>
        </li>
        <span v-if="!encounters.filter(encounter => encounter?.status === 'c' || encounter?.status === 'o').length">
          <li class="divider" tabindex="-1"></li>
          <li @click.prevent="handleClose">
            <a href="#">Close Claims</a>
          </li>
        </span>
      </ul>
    </div>
  </nav>
</template> -->

            <!-- Error -->
            <div class="claim-add-notification is-error" role="alert" v-if="error">
              <i class="material-icons" aria-hidden="true">error_outline</i>
              <span>{{ error }}</span>
            </div>

            <!-- Success -->
            <SubmitSummary :cluster="success" @restart="handleRestart" v-if="success" />

            <!-- Main Displays  -->
            <div v-if="currState === 'c'">
              <template v-if="cluster">
                <div class="claim-add-content-layer">
                  <EnrolleeClaim :cluster="cluster" :reload="encounter" @next="handleNext" v-if="next" />

                  <div v-else>
                    <SummaryClaim :encounters="encounters" :isSubmitting="isSubmitting" :isManual="true"
                      @reload="handleReload" />

                    <div class="claim-add-action-row">
                      <div class="claim-add-action-group">
                        <button
                          type="button"
                          class="claim-add-action-btn is-add"
                          :class="{ disabled: isSubmitting }"
                          @click="handleAdd"
                        >
                          <i class="material-icons">add</i>
                          <span>Add Claim</span>
                        </button>
                        <button
                          type="button"
                          class="claim-add-action-btn is-save"
                          :class="{
                            disabled: isSubmitting,
                            'is-ready': encounters.filter(encounter => encounter.status === 'c' || encounter.status === 'o').length,
                          }"
                          @click="handleSave"
                        >
                          <i class="material-icons">save</i>
                          <span>Save</span>
                        </button>
                      </div>

                      <button
                        type="button"
                        class="claim-add-action-btn is-submit"
                        :class="{ disabled: isSubmitting || !encounters.length }"
                        @click.prevent="handleConfirmOpen"
                      >
                        <i class="material-icons">check_circle</i>
                        <span>{{ isSubmitting ? "Submit" : "Final Submit" }}</span>
                      </button>
                    </div>

                  </div>
                </div>
              </template>

              <StartClaim @next="handleNext" v-if="!cluster" />
            </div>

            <!-- User Displays  -->
            <SavedClaimUser @restart="handleRestart" v-if="currState === 'u'" />

            <!-- HMO Displays  -->
            <SavedClaimHMO @restart="handleRestart" v-if="currState === 'h'" />
          </section>
        </div>

      </template>

    </div>
  </div>
  </div>

  <Teleport to="body">
    <div class="claim-submit-confirm-overlay" @click.self="handleConfirm(false)" v-if="isConfirmSubmitOpen">
      <section class="claim-submit-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="claim-submit-confirm-title">
        <div class="claim-submit-confirm-content">
          <h4 id="claim-submit-confirm-title">{{ alertTitle }}</h4>
          <p>{{ alertMessage }}</p>
        </div>
        <div class="claim-submit-confirm-footer">
          <button type="button" class="claim-submit-confirm-btn is-cancel" @click.prevent="handleConfirm(false)">
            Cancel
          </button>
          <button type="button" class="claim-submit-confirm-btn is-confirm" @click.prevent="handleConfirm(true)">
            Confirm
          </button>
        </div>
      </section>
    </div>
  </Teleport>
</template>


<script>
import { ref, onMounted, onUpdated, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import useModuleNavigation from "@/composables/useModuleNavigation";
import { ageSex, capWordsFx, } from "@/composables/fxLibrary/coreFx";
import { getFullMonthName } from "@/composables/fxLibrary/months";
import { syncSavedEnrollee } from "@/composables/serverCaller/serverCaller";
import postItem from "@/composables/postItem";
import LoadingDiv from "@/components/LoadingDiv.vue";
import UiPageHeader from "@/ui/components/UiPageHeader.vue";
import { ArrowLeft } from "@lucide/vue";
import SavedClaimUser from "@/components/claim/SavedClaimUserComponent.vue";
import SavedClaimHMO from "@/components/claim/SavedClaimHMOComponent.vue";
import StartClaim from "@/components/claim/StartClaimComponent.vue";
import EnrolleeClaim from "@/components/claim/EnrolleeClaimComponent.vue";
import SummaryClaim from "@/components/claim/SummaryClaimComponent.vue";
import SubmitSummary from "@/components/claim/SubmitSummaryClaimComponent.vue";
import ModalNotify from "@/components/alerts/ModalNotificationComponent.vue";
import nativeUi from "@/ui/native-ui";

export default {
  name: "claimsAdd",
  components: { ArrowLeft, LoadingDiv, SavedClaimUser, SavedClaimHMO, StartClaim, EnrolleeClaim, SummaryClaim, SubmitSummary, ModalNotify, UiPageHeader },
  setup() {
    const isReady = ref(true);
    const isSubmitting = ref(false);
    const cluster = ref(null);
    const encounter = ref(null);
    // const editId = ref(null);
    const next = ref(false);
    const error = ref(null);
    const success = ref(null);
    const notifyTitle = ref(null);
    const notifyMessage = ref(null);
    const alertTitle = ref("Confirm");
    const alertMessage = ref("Are you sure you want to submit? Please confirm that all the details provided are accurate. Once submitted, changes cannot be made unless approved by a supervisor.");
    const isConfirmSubmitOpen = ref(false);
    const home = ref({ id: 1, name: "Claims", title: "All", url: "claim", hash: null });
    const tabsState = ref([]);
    const currState = ref(null);

    // vue router
    const router = useRouter();
    const { routeToTab } = useModuleNavigation();

    // store
    const store = useStore();

    // start
    onMounted(() => {
      // page name
      document.title = "Add Claims";
    });

    // menu
    onMounted(() => {
      // restart if availiable
      handleRestart();
    });

    // handle restart
    const handleRestart = () => {
      // reload, if available
      if (store.state.cluster) {
        cluster.value = store.state.cluster;
      }

      // clear all
      handleClear();

      // set default
      currState.value = "c";
    }

    // start
    onMounted(() => {
      // load tab
      tabsState.value.push({ id: 1, title: "Current", state: "c" });
      tabsState.value.push({ id: 2, title: `Saved (${store.state.user?.slug})`, state: "u" });
      tabsState.value.push({ id: 3, title: "Saved (HMO)", state: "h" });

      // set default
      currState.value = "c";
    });

    // change state
    const handleState = (val) => {

      // clear all
      handleClear();

      // set
      if (val) {
        currState.value = val;
        router.push({ hash: "#top" });
      }

    }

    // close notification
    const handleOk = () => {
      // clear notification
      notifyTitle.value = null;
      notifyMessage.value = null;
      // Restore scrollbar (insurance)
      resetScrollBar();
    }

    // open
    const openNotifyModal = () => {
      const notifyElement = document.getElementById("notify");
      if (notifyElement) {
        var notifyInstance = nativeUi.Modal.init(notifyElement, {}); // Ensure initialization
      }
      notifyInstance.open();
    };

    // more
    onUpdated(() => {
      var elems = document.querySelectorAll(".dropdown-trigger");
      nativeUi.Dropdown.init(elems, {});
    });

    // alert
    onMounted(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      nativeUi.Modal.init(elems, {});
    });

    // alert
    onUpdated(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      nativeUi.Modal.init(elems, {});
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // scrollbar
    const resetScrollBar = () => {
      // Restore scrollbar (insurance)
      document.body.style.overflow = 'auto';
    }

    // clear all
    const handleClear = () => {
      error.value = null;
      success.value = null;
    }

    // review
    const handleActiveState = (val) => {
      // switch to display
      if (val == "v") {
        currState.value = "v";
      } else if (val == "d") {
        currState.value = "d";
      } else if (val == "s") {
        currState.value = "s";
      }
    };

    // handle curr status
    const handleActive = (tab) => {
      routeToTab(tab, { replace: !tab?.url });
    };

    // handle next
    const handleNext = async (val) => {

      // clear all 
      // notifications
      handleClear();

      // continue
      if (!cluster.value) {
        // start
        isReady.value = false;

        // setup
        let newVal = {
          provider_id: val.provider.search,
          month_year: `${val.month.search}_${val.year.search}`,
          scheme_id: val.scheme.search,
          user_id: store.state.user.id,
          slug: store.state.user.slug,
        };

        // post update
        const { res } = await postItem("cluster", newVal);

        if (res.value) {
          // !res.value.data.encounters.length
          if (res.value.data.status === 'q') {
            // load all from server
            cluster.value = { ...res.value.data }; // ...val

            // convert month_year
            let monthYear = cluster.value.month_year.split("_");
            // month
            cluster.value.month = { search: Number(monthYear[0]), name: getFullMonthName(monthYear[0] - 1) };
            // year
            cluster.value.year = { search: Number(monthYear[1]), name: monthYear[1] };

            // uptimize claims
            cluster.value.encounters.forEach((encounter) => {
              encounter.claims.forEach((claim) => {
                claim.claim = claim.item
                claim.qty = claim.sent_qty
                claim.amt = claim.sent_price
                claim.standard = claim.standard_price
              })
            })

            // save payload
            store.commit("loadCluster", cluster.value);

            // open enrolleeClaim
            if (cluster.value.encounters.length) {
              next.value = false;
            }

            // warning
            if (res.value.data.user?.type !== "hmo") {

              // encounter is already actived by provider
              notifyTitle.value = "Important Notice";
              notifyMessage.value = `${cluster.value.provider.name} (${cluster.value.scheme.name}) 
              ${cluster.value.month.name} ${cluster.value.year.name} Claims has already been activated by the Provider. 
              Proceed only if you are taking over claims input from Provider.`
              // wait this out a bit
              setTimeout(function () {
                openNotifyModal();
              }, 2000);

            }

          } else {
            // future insurance: 
            // Cluster DB don't have 'd' at the moment
            if (res.value.data.status === 'd') {
              error.value = "Claims month is Deleted";
            } else {
              error.value = "Claims month already active!";
            }
          }
        } else {
          error.value = "Error starting claims. Try again!";
        }

        //end
        isReady.value = true;

      } else {

        if ("encounter" in val) {

          // sort out 
          let syncEnrolleeSaved = await syncSavedEnrollee(val, cluster.value);

          // cont.
          if (syncEnrolleeSaved !== null) {

            // start 
            // main action
            let newVal = true;

            // start
            if (!val.encounter.claims.length || val.encounter.status === "d") {

              // remove for deleted
              let newClusterEncounters = cluster.value.encounters.filter(x => x.editId !== val.encounter.editId);
              cluster.value.encounters = newClusterEncounters;

              // prevent new push
              newVal = false;


            } else {


              // update old encounter if edit
              cluster.value.encounters.forEach((x, y) => {

                if (x.editId == val.encounter.editId) {

                  // update here
                  cluster.value.encounters[y] = val.encounter;

                  // prevent new push
                  newVal = false;
                }

              });

            }


            // set new encounter
            if (newVal) {
              cluster.value.encounters.push(val.encounter);
            }


            // update server
            // save payload
            store.commit("loadCluster", cluster.value);


            // if submit
            if (val.submit) {
              // close encounter
              encounter.value = null;
              // close enrolleeClaim
              next.value = false;
            }


          } else {

            // server sync FAILED for savedEnrollee
            // so return to home page

            // close encounter
            encounter.value = null;
            // close enrolleeClaim
            next.value = false;

            // load back original store
            // aproko Vue updates arrays without asking it
            // so last saved copy is old_
            cluster.value.encounters.forEach((x, y) => {

              if (x.editId == val.encounter.editId) {

                if (val.encounter?.old_diagnosis) {
                  // retun to original diagnosis
                  cluster.value.encounters[y].diagnosis = val.encounter?.old_diagnosis;
                }

                if (val.encounter?.old_encounter_date) {
                  // retun to original encounter_date
                  cluster.value.encounters[y].encounter_date = val.encounter?.old_encounter_date;
                }

                if (val.encounter?.old_encounter_date_end) {
                  // retun to original encounter_date_end
                  cluster.value.encounters[y].encounter_date_end = val.encounter?.old_encounter_date_end;
                }

              }

            });

          }

        }

      }
    };

    // handle reload
    const handleReload = (val) => {
      encounter.value = val.encounter;
      // editId.value = val.encounter.editId;
      next.value = true;
    };

    // handle review
    const handleReview = (val) => {
      if (val == "view") {
        next.value = false;
      } else if (val == "add") {
        next.value = true;
      }
    };

    // handle close
    const handleClose = () => {
      // clear up saved
      // insurance, double check there is no unsaved encounter/claims
      if (!store.state.cluster?.encounters.filter(encounter => encounter.status === 'c' || encounter.status === 'o').length) {

        // clear store
        store.commit("loadCluster", null);

        // continue
        if (cluster.value.user_id === store.state.user.id) {
          handleState("u"); // c=current, u=user, h=hmo, n=null
        } else {
          handleState("h"); // c=current, u=user, h=hmo, n=null
        }

        // clear
        cluster.value = null;

      }
    }

    // handle add
    const handleAdd = () => {
      // open new
      next.value = true;
      // close old encounter
      encounter.value = null;
    };

    // handle save
    const handleSave = () => {
      if (encounters.value.filter(encounter => encounter.status === 'c' || encounter.status === 'o').length) {
        handleSubmit("q"); // q = keep un-submitted
      } else {
        handleClose() // nothing to save
      }
    }

    const handleConfirmOpen = () => {
      if (isSubmitting.value || !encounters.value.length) {
        return;
      }

      isConfirmSubmitOpen.value = true;
    };

    // confirmation
    const handleConfirm = (val) => {
      isConfirmSubmitOpen.value = false;

      // call submit if confirmed
      if (val) {
        // p = submitted
        handleSubmit("p");
      } else {
        // Restore scrollbar (insurance)
        resetScrollBar();
      }
    }

    // handle review
    const handleSubmit = async (clusterStatusVal) => {

      // clear all 
      // notifications
      handleClear();

      // start
      isSubmitting.value = true;

      // start
      let approved;
      let comment;
      let newCluster;
      let newEncounter;
      let newEncounters = [];
      let newClaims = [];
      let keysToRemove = ["id", "scheme", "created_at", "updated_at", "editId", "claims", "status"];
      let pendingEncounters = encounters.value.filter(encounter => encounter.status === 'c' || encounter.status === 'o'); //c & o

      // un-submitted encounters && claims
      pendingEncounters.forEach((x) => {
        // sort encounters
        newEncounter = {
          ...Object.fromEntries(
            Object.entries(x).filter(
              ([key]) => !keysToRemove.includes(key)
            )
          ),
        };
        newEncounter = ({
          ...newEncounter,
          encounter_cluster_id: cluster.value.id,
          provider_id: cluster.value.provider_id,
          status: "p", // ready for vetting
        })

        // sort claims
        x.claims.forEach((z) => {
          // vet claims
          if ((z.amt) > (z.qty * z.standard)) {
            approved = z.qty * z.standard;
            comment = "Over Billing";
          } else {
            approved = z.amt;
            comment = null;
          }

          // extra security
          if (z.status === "a") {
            // format
            newClaims.push({
              encounter_id: null,
              item: z.claim,
              sent_qty: z.qty,
              sent_price: z.amt,
              approved_qty: z.qty,
              approved_price: approved,
              standard_price: z.standard,
              authorization_code: z?.authorization_code,
              comment: comment,
            })

          }

        })

        // put everything together
        newEncounters.push({ encounter: newEncounter, claims: newClaims });

        // clean up and go again
        newEncounter = null;
        newClaims = [];

      });

      // update cluster status
      newCluster = {
        id: cluster.value.id,
        status: clusterStatusVal, // set to submitted or unsubmitted by input
      }

      // convert to user's cluster
      if (cluster.value.user?.type !== "hmo") {
        newCluster = {
          ...newCluster,
          user_id: store.state.user.id,
          slug: store.state.user.slug,
        }
      }

      // setup
      let newVal = {
        cluster: newCluster,
        encounters: newEncounters,
      };

      // post update
      const { res, err } = await postItem("encounter/claims/cluster/bulk", newVal);

      if (res.value) {
        // clear temp save
        store.commit("loadCluster", null);

        // next action
        if (res.value.data.status === "q") {

          // continue
          if (res.value.data.user_id === store.state.user.id) {
            handleState("u"); // c=current, u=user, h=hmo, n=null
          } else {
            handleState("h"); // c=current, u=user, h=hmo, n=null
          }

          // clear
          cluster.value = null;


        } else {

          if (res.value.data.status === "p") {
            // load success cluster
            res.value.data.month = cluster.value.month.name;
            res.value.data.year = cluster.value.year.name;
            const isRelatedClaim = res.value.data.ref !== "a" || res.value.data.type !== "original";
            // change to display
            // success.value = res.value.data; 
            // start again
            currState.value = null;
            // clear
            cluster.value = null;
            // notify (Toast)
            nativeUi.toast({
              html: "Claims Added Successfully <i class='material-icons'>check_circle</i>", // Toast content
              // classes: 'green rounded', // Add custom classes
              displayLength: 5000, // Duration in milliseconds
              inDuration: 300, // Transition in duration
              outDuration: 300, // Transition out duration
            });

            if (isRelatedClaim) {
              router.push({ name: "claimView", params: { clusterId: res.value.data.id } });
              return;
            }

            // nothing, just back home
            handleState("c"); // c=current, u=user, h=hmo, n=null
          } else {
            // nothing, just back home
            handleState("c"); // c=current, u=user, h=hmo, n=null
          }

        }

      } else {
        error.value = err.value;
      }

      // Restore scrollbar (insurance)
      resetScrollBar();

      // end
      isSubmitting.value = false; // in case of incasecity!
    };

    // output claims results
    const encounters = computed(() => {
      if (!("encounters" in cluster.value)) {
        return [];
      } else {
        return cluster.value.encounters;
      }
    });

    return {
      handleRestart,
      handleActive,
      handleActiveState,
      home,
      tabsState,
      currState,
      capWords,
      showAgeSex,
      handleOk,
      handleClear,
      handleState,
      handleConfirm,
      handleReview,
      handleNext,
      handleReload,
      handleAdd,
      handleClose,
      handleSave,
      handleConfirmOpen,
      handleSubmit,
      notifyTitle,
      notifyMessage,
      alertTitle,
      alertMessage,
      isConfirmSubmitOpen,
      success,
      error,
      isReady,
      isSubmitting,
      next,
      cluster,
      encounter,
      encounters,
    };
  },
};
</script>

<style scoped>
.claim-add-page {
  box-sizing: border-box;
  margin: 0 auto;
  max-width: var(--ui-content-width);
  padding: 2rem 2rem 3rem;
  width: 100%;
}

.claim-add-intro {
  border-bottom: 1px solid var(--ui-border);
  margin-bottom: 2rem;
  padding-bottom: 1.75rem;
}

.claim-add-intro :deep(.ui-page-header) {
  margin-bottom: 0;
}

.claim-add-intro :deep(.ui-page-header__title) {
  font-size: clamp(1.75rem, 2.1vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}

.claim-add-intro :deep(.ui-page-header__description) {
  font-size: 1rem;
  line-height: 1.55;
}

.claim-all-link {
  align-items: center;
  background: var(--ui-primary);
  border: 1px solid var(--ui-primary);
  border-radius: calc(var(--ui-radius) - 2px);
  color: var(--ui-primary-foreground);
  cursor: pointer;
  display: inline-flex;
  font-size: 0.8125rem;
  font-weight: 600;
  gap: 0.5rem;
  justify-content: center;
  min-height: 2.5rem;
  padding: 0 0.9rem;
}

.claim-all-link:hover {
  filter: brightness(0.95);
}

.claim-all-link:focus-visible {
  outline: 2px solid var(--ui-ring);
  outline-offset: 2px;
}

.claim-add-page > .sba-collection-page-surface {
  background: transparent;
  border: 0;
  min-height: 0;
  padding-bottom: 0;
}

.claim-add-container {
  margin: 0;
  max-width: none;
  padding: 0;
  width: 100%;
}

.claim-add-workbench {
  color: #263238;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
}

.claim-add-super-card,
.claim-add-dossier-card,
.claim-add-mode-strip,
.claim-add-body-frame,
.claim-add-submode-strip,
.claim-add-content-layer,
.claim-add-action-row,
.claim-add-workbench :deep(.claim-start-panel),
.claim-add-workbench :deep(.claim-start-section),
.claim-add-workbench :deep(.claim-summary-card),
.claim-add-workbench :deep(.claim-summary-row),
.claim-add-workbench :deep(.claim-submit-summary),
.claim-add-workbench :deep(.saved-claim-card),
.claim-add-workbench :deep(.saved-claim-empty),
.claim-add-workbench :deep(.enrollee-claim-card),
.claim-add-workbench :deep(.enrollee-claim-panel) {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.claim-add-secondary-header {
  margin-bottom: 0;
  position: relative;
}

.claim-add-dossier-card,
.claim-add-super-card,
.claim-add-mode-strip,
.claim-add-body-frame,
.claim-add-submode-strip {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: none;
}

.claim-add-super-card {
  align-items: center;
  background: #ffffff;
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 10px 20px -24px rgba(38, 50, 56, 0.34);
  display: flex;
  gap: 10px;
  min-height: 46px;
  padding: 10px 14px;
  position: relative;
  width: 100%;
  z-index: 3;
}

.claim-add-super-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.15;
}

.claim-add-dossier-card {
  align-items: center;
  border-color: var(--ui-border);
  border-radius: 6px 6px 0 0;
  box-shadow: none;
  display: flex;
  gap: 22px;
  justify-content: space-between;
  padding: 26px 34px;
  position: relative;
}

.claim-add-dossier-title label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.secondary-page-back {
  align-items: center;
  background: #00897b;
  border: 1px solid #00796b;
  border-radius: 5px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  height: 24px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 24px;
}

.secondary-page-back:hover {
  background: #00695c;
  border-color: #00695c;
}

.secondary-page-back i {
  color: #ffffff;
  font-size: 16px;
  line-height: 16px;
}

.secondary-parent-link {
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #4e342e;
  cursor: pointer;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 800;
  margin: 0;
  padding: 0;
  text-align: left;
  text-transform: uppercase;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.secondary-parent-link:hover {
  color: #00897b;
}

.claim-add-super-copy small {
  color: #6d4c41;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: none;
}

.claim-add-dossier-title h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.claim-add-dossier-title p {
  color: #607d8b;
  line-height: 1.55;
  margin: 7px 0 0;
  max-width: 760px;
}

.claim-add-dossier-title {
  flex: 1 1 auto;
  min-width: 0;
}

.claim-add-dossier-context {
  align-items: flex-end;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  max-width: 430px;
}

.context-pill {
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 8px 11px;
}

.context-pill.is-active {
  background: #e0f2f1;
  border-color: #80cbc4;
  color: #00695c;
}

.context-pill.is-count {
  background: #eceff1;
  color: #263238;
}

.claim-add-mode-strip {
  align-items: center;
  background: #ffffff;
  border-top: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
  margin-bottom: 0;
  padding: 10px 16px;
}

.claim-add-submode-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 180px;
}

.claim-add-submode-copy span {
  color: #263238;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
}

.claim-add-submode-copy small {
  color: #607d8b;
  font-size: 0.76rem;
  font-weight: 600;
}

.claim-add-mode-actions,
.claim-add-submode-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
}

.claim-add-mode-actions {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  gap: 6px;
  padding: 5px;
}

.claim-add-mode-option,
.claim-add-close-option {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #c4d3d9;
  border-radius: 5px;
  box-shadow: 0 8px 16px -18px rgba(38, 50, 56, 0.8);
  color: #263238;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.8rem;
  font-weight: 800;
  gap: 6px;
  letter-spacing: 0;
  min-height: 38px;
  padding: 0 16px;
  text-align: center;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;
}

.claim-add-mode-option:hover,
.claim-add-close-option:hover {
  background: #eef7f7;
  border-color: #80cbc4;
  box-shadow: 0 10px 18px -18px rgba(0, 105, 92, 0.55);
  color: #00695c;
}

.claim-add-mode-option.is-active {
  background: #263238;
  border-color: #263238;
  box-shadow: 0 10px 18px -14px rgba(38, 50, 56, 0.9);
  color: #ffffff;
}

.claim-add-submode-option {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #455a64;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.8rem;
  font-weight: 800;
  gap: 5px;
  min-height: 34px;
  padding: 0 11px;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.claim-add-submode-option:hover {
  background: #f4f7f8;
  border-color: #d7e1e5;
  color: #00695c;
}

.claim-add-submode-option.is-active {
  background: #ffffff;
  border-color: #80cbc4;
  box-shadow: inset 0 -2px 0 #26a69a;
  color: #00695c;
}

.claim-add-close-option {
  background: #ffffff;
  border-color: #d7e1e5;
  border-radius: 6px;
  color: #00695c;
  min-height: 32px;
}

.claim-add-close-option:hover {
  border-color: #90a4ae;
}

.claim-add-close-option i {
  font-size: 16px;
}

.claim-add-body-frame {
  background: #ffffff;
  border: 1px solid var(--ui-border);
  border-top: 0;
  border-radius: 0 0 6px 6px;
  box-shadow: none;
  padding: 16px;
  position: relative;
}

.claim-add-submode-strip {
  align-items: center;
  background: #ffffff;
  border-color: var(--ui-border);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 0;
  padding: 12px 14px;
}

.claim-add-content-layer {
  background: #ffffff;
  border: 1px solid var(--ui-border);
  border-radius: 0 0 6px 6px;
  border-top: 0;
  margin-bottom: 14px;
  padding: 16px;
}

.claim-add-action-row {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-radius: 0;
  border-top: 1px solid var(--ui-border);
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: space-between;
  margin-top: 20px;
  padding: 16px 0 0;
}

.claim-add-notification {
  align-items: flex-start;
  border: 1px solid;
  border-radius: 6px;
  display: flex;
  font-size: 0.875rem;
  font-weight: 650;
  gap: 9px;
  line-height: 1.45;
  margin: 0 0 16px;
  padding: 12px 14px;
}

.claim-add-notification i {
  flex: 0 0 auto;
  font-size: 19px;
}

.claim-add-notification.is-error {
  background: #fff1f2;
  border-color: #fecdd3;
  color: #b42335;
}

.claim-add-action-group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}

.claim-add-action-btn {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.84rem;
  font-weight: 800;
  gap: 8px;
  justify-content: center;
  letter-spacing: 0;
  min-height: 42px;
  padding: 0 16px;
  transition: background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease, opacity 0.18s ease;
}

.claim-add-action-btn i {
  font-size: 18px;
  line-height: 18px;
}

.claim-add-action-btn.disabled {
  cursor: default;
  opacity: 0.52;
  pointer-events: none;
}

.claim-add-action-btn.is-add {
  background: #263238;
  border-color: #263238;
  box-shadow: 0 8px 16px -14px rgba(38, 50, 56, 0.9);
  color: #ffffff;
}

.claim-add-action-btn.is-add:hover {
  background: #102027;
  border-color: #102027;
}

.claim-add-action-btn.is-save {
  background: #ffffff;
  border-color: #b0bec5;
  color: #37474f;
}

.claim-add-action-btn.is-save:hover {
  background: #eef3f6;
  border-color: #78909c;
}

.claim-add-action-btn.is-save.is-ready {
  background: #e3f2fd;
  border-color: #64b5f6;
  color: #0d47a1;
}

.claim-add-action-btn.is-submit {
  background: #00695c;
  border-color: #004d40;
  box-shadow: 0 10px 18px -14px rgba(0, 77, 64, 0.9);
  color: #ffffff;
  margin-left: auto;
  min-width: 150px;
}

.claim-add-action-btn.is-submit:hover {
  background: #004d40;
}

.claim-submit-confirm-overlay {
  align-items: center;
  background: rgba(38, 50, 56, 0.48);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1800;
}

.claim-submit-confirm-modal {
  background: #ffffff;
  border: 1px solid #d7e1e5;
  border-radius: 6px;
  box-shadow: 0 24px 60px rgba(38, 50, 56, 0.28);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 96px);
  max-width: 720px;
  width: min(720px, 100%);
}

.claim-submit-confirm-content {
  overflow-y: auto;
  padding: 34px 36px 22px;
}

.claim-submit-confirm-content h4 {
  color: #263238;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0 0 18px;
}

.claim-submit-confirm-content p {
  color: #263238;
  font-size: 1rem;
  line-height: 1.55;
  margin: 0;
}

.claim-submit-confirm-footer {
  align-items: center;
  border-top: 1px solid #e1e8eb;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 12px 18px;
}

.claim-submit-confirm-btn {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 5px;
  color: #37474f;
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 800;
  min-height: 36px;
  padding: 0 14px;
  text-transform: uppercase;
}

.claim-submit-confirm-btn:hover {
  background: #eef3f6;
}

.claim-submit-confirm-btn.is-confirm {
  color: #00695c;
}

.claim-add-body-frame :deep(.section) {
  padding-bottom: 0;
  padding-top: 0;
}

.claim-add-body-frame :deep(.card),
.claim-add-body-frame :deep(.card-panel) {
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  box-shadow: none;
}

.claim-add-body-frame :deep(.card) {
  overflow: hidden;
}

.claim-add-body-frame :deep(.grey.lighten-4),
.claim-add-body-frame :deep(.grey.lighten-5) {
  background-color: #f8fafb !important;
}

.claim-add-content-layer :deep(.card),
.claim-add-content-layer :deep(.card-panel) {
  margin-bottom: 14px;
}

.claim-add-content-layer :deep(.card-content) {
  padding: 20px 24px;
}

.claim-add-content-layer :deep(.card-title) {
  color: #263238;
  font-size: 1.18rem;
  font-weight: 700;
}

.claim-add-content-layer :deep(.teal.lighten-5) {
  background-color: #e8f6f6 !important;
}

.claim-add-content-layer :deep(.yellow.lighten-1) {
  background-color: #fff176 !important;
  border-radius: 4px;
}

.claim-add-content-layer :deep(.collection) {
  border-color: #d7e1e5;
  border-radius: 6px;
  overflow: hidden;
}

.claim-add-content-layer :deep(.collection-item) {
  border-bottom-color: #e1e8eb;
}

.claim-add-content-layer :deep(.btn),
.claim-add-content-layer :deep(.btn-large) {
  border-radius: 6px;
  box-shadow: 0 8px 16px -14px rgba(38, 50, 56, 0.9);
  font-weight: 800;
  letter-spacing: 0;
}

.progress {
  margin-top: -15px;
}

.clickable {
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.clickable:hover {
  opacity: 0.8;
}

.pointable {
  cursor: default;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.pointable:hover {
  opacity: 0.8;
}

.spacer {
  padding: 2px;
}

.pointer {
  cursor: default;
}

@media only screen and (max-width: 992px) {
  .claim-add-dossier-card {
    align-items: flex-start;
    flex-direction: column;
  }

  .claim-add-dossier-context {
    justify-content: flex-start;
    max-width: none;
    min-width: 0;
    width: 100%;
  }

  .claim-add-mode-strip,
  .claim-add-submode-strip {
    align-items: flex-start;
    flex-direction: column;
  }

  .claim-add-mode-actions,
  .claim-add-submode-actions {
    justify-content: flex-start;
    width: 100%;
  }
}

@media only screen and (min-width: 701px) and (max-width: 992px) {
  .claim-add-page-shell {
    width: 92%;
  }

  .claim-add-dossier-card,
  .claim-add-mode-strip,
  .claim-add-submode-strip {
    padding: 22px;
  }

  .claim-add-mode-actions,
  .claim-add-submode-actions {
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: auto;
    padding-bottom: 4px;
  }

  .claim-add-mode-option,
  .claim-add-submode-option,
  .claim-add-close-option {
    flex: 0 0 auto;
  }

  .claim-add-body-frame,
  .claim-add-content-layer {
    padding: 18px;
  }
}

@media only screen and (max-width: 992px) {
  .claim-add-page {
    padding-inline: 1.25rem;
  }
}

@media only screen and (max-width: 700px) {
  .claim-add-page {
    padding: 1.25rem 1rem 2.5rem;
  }

  .claim-add-intro {
    margin-bottom: 1.5rem;
    padding-bottom: 1.25rem;
  }

  .claim-all-link {
    width: 100%;
  }

  .claim-add-super-card {
    align-items: flex-start;
  }

  .claim-add-dossier-card {
    padding: 22px;
  }

  .claim-add-dossier-title h5 {
    font-size: 1.45rem;
  }

  .claim-add-dossier-title p {
    font-size: 0.94rem;
  }

  .claim-add-dossier-context {
    gap: 6px;
  }

  .claim-add-mode-actions,
  .claim-add-submode-actions {
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
  }

  .claim-add-mode-actions::-webkit-scrollbar,
  .claim-add-submode-actions::-webkit-scrollbar {
    display: none;
  }

  .claim-add-mode-option,
  .claim-add-submode-option,
  .claim-add-close-option {
    flex: 0 0 auto;
  }

  .claim-add-body-frame {
    padding: 12px;
  }

  .claim-add-content-layer {
    padding: 12px;
  }

  .claim-add-content-layer :deep(.card-content),
  .claim-add-content-layer :deep(.card-panel) {
    padding: 16px;
  }

  .claim-add-action-row {
    align-items: stretch;
    flex-direction: column;
  }

  .claim-add-action-group {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .claim-add-action-btn,
  .claim-add-action-btn.is-submit {
    margin-left: 0;
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .claim-add-super-card,
  .claim-add-dossier-card,
  .claim-add-mode-strip,
  .claim-add-body-frame,
  .claim-add-submode-strip,
  .claim-add-content-layer,
  .claim-add-action-row,
  .claim-add-workbench :deep(.claim-start-panel),
  .claim-add-workbench :deep(.claim-start-section),
  .claim-add-workbench :deep(.claim-summary-card),
  .claim-add-workbench :deep(.claim-summary-row),
  .claim-add-workbench :deep(.claim-submit-summary),
  .claim-add-workbench :deep(.saved-claim-card),
  .claim-add-workbench :deep(.saved-claim-empty),
  .claim-add-workbench :deep(.enrollee-claim-card),
  .claim-add-workbench :deep(.enrollee-claim-panel) {
    animation: none;
  }
}
</style>
